export default __webpack_public_path__ + "static/media/5490520A.6e9f9789.png";